import React, { useContext, useState, useEffect } from "react";
import "../../Styles/globalStyle.css";
import useSize from "../../../Hooks/useSize.js";
import useBuildStyle from "../../../Hooks/useBuildStyle";

export default function Button(props) {
  const [actualWidth, actualHeight] = useSize(props.style.width.value, props.style.height.value, props.data.id);
  const buildStyle = useBuildStyle();

  useEffect(() => {
    props.updateSize(props.data.id, actualWidth, actualHeight);
  }, [actualWidth,actualHeight]);

  const getContainerStyle = () => {
    var newStyle = buildStyle(props.style);
    newStyle["backgroundColor"] = "transparent";
    return newStyle;
  };
 

  const getStyle = () => {
    var newStyle = {};
    newStyle["fontSize"] = props.style.fontSize.value;
    newStyle["fontFamily"] = props.style.fontFamily.value;
    newStyle["color"] = props.style.color.value;
    //newStyle["border"] = props.style.border.value;

    newStyle["borderLeft"] = props.style.borderLeft.value;
    newStyle["borderTop"] = props.style.borderTop.value;
    newStyle["borderTopLeftRadius"] = props.style.borderTopLeftRadius.value;
    newStyle["borderTopRightRadius"] = props.style.borderTopRightRadius.value;

    newStyle["borderRight"] = props.style.borderRight.value;
    newStyle["borderBottom"] = props.style.borderBottom.value;
    newStyle["borderBottomLeftRadius"] = props.style.borderBottomLeftRadius.value;
    newStyle["borderBottomRightRadius"] = props.style.borderBottomRightRadius.value;

    newStyle["backgroundColor"] = props.style.backgroundColor.value;
    newStyle["width"] =parseInt(props.style.width.value.slice(0,-2)) - 10 + "px";
    newStyle["height"] = parseInt(props.style.height.value.slice(0,-2)) - 10 + "px";
   
    return newStyle;
  };
 
  return (
    <div  draggable={props.draggable}
    onDragStart={(e) => props.onDragStart(e)}
    id={props.data.id}
    style={getContainerStyle()}
    onClick={props.onClick}
    >
  
      <input
        type="button"
        className="button"
        onClick={(e) => props.onClick(e)}
        draggable={props.draggable}
        onDragStart={(e) => props.onDragStart(e)}
        style={getStyle()}
        value={props.data.properties.text.value}
      />
       
    
    </div>
  );
}
